export default {"src":"/_next/static/media/notecard.5aca092e.svg","height":256,"width":362,"blurWidth":0,"blurHeight":0};